import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Input, LoginBox, LoginContainer, Title } from "../../signatures/loginSignatures/styles";

const LoginSingleCharge: React.FC = () => {
  const [password, setPassword] = React.useState('');
  const history = useHistory();

  const predefinedPassword = '7K7^rl+x,Bah9o{hQ';

  const handleLogin = () => {
    if(password === predefinedPassword){
      history.push('/admin/cobranca-avulsa')
    } else {
      toast.error("Senha incorreta!");
    }
  };

  return(
    <LoginContainer>
      <LoginBox>
        <Title>Login Cobrança Pontual</Title>
        <Input
          type="password"
          placeholder="Insira a senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginSingleCharge;